import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import * as utils from '@ivy/fts/utils';
import * as _ from 'underscore';
let OrderPay = class OrderPay extends Vue {
    constructor() {
        super(...arguments);
        this.aliPayForm = '';
        this.paying = true;
        this.order_id = '';
        this.redirect = '';
    }
    get isWeixinWeb() {
        return utils.isWeixin();
    }
    created() {
        let query = this.$route.query;
        if (query.paying) {
            this.paying = true;
        }
        else {
            this.paying = false;
        }
    }
    async mounted() {
        let { _redirect, combine_pay = '' } = this.$route.query;
        this.bindVisible();
        let redUrl = new URL(decodeURIComponent(_redirect + ''));
        this.redirect = '/goods/payDone' + redUrl.search;
        console.log(redUrl);
        if (!this.isWeixinWeb) {
            // 请求支付宝表单
            let { data } = await this.$axios.post('/api/goods/v1/order/aliPayOrder', {
                ..._.omit(this.$route.query, '_redirect'),
                combine_pay: combine_pay ? JSON.parse(combine_pay + '') : '',
                redirect: '/goods/aliPayResult' + redUrl.search,
            });
            console.log('----', data);
            this.$el.querySelector('#form-div').innerHTML =
                data.transaction_id || data.prepay_id;
            setTimeout(function () {
                // history.replaceState(
                //   null,
                //   null,
                //   location.pathname + location.search + '#handled'
                // )
                document.forms[0].submit();
            }, 200);
        }
    }
    bindVisible() {
        document.addEventListener('visibilitychange', this.visibilityChange);
    }
    visibilityChange() {
        var isHidden = document.hidden;
        console.log('isHidden', isHidden);
        if (!isHidden) {
            // 查询是否支付订单
            console.log('微信内需要查询订单是否支付');
            if (this.isWeixinWeb) {
                this.$axios
                    .get('/api/goods/v1/order/checkOrderPay', {
                    params: {
                        order_id: this.$route.query.order_id,
                    },
                })
                    .then(res => {
                    console.log('=====', res);
                    console.log('需要跳转至订单完成页');
                    if (res.data) {
                        // alert(this.redirect)
                        // this.$router.replace(this.redirect)
                        location.replace(this.redirect);
                    }
                    else {
                        this.$Toast(`订单未支付`);
                    }
                });
            }
        }
    }
    destroyed() {
        document.removeEventListener('visibilitychange', this.visibilityChange);
    }
};
OrderPay = tslib_1.__decorate([
    Component({})
], OrderPay);
export default OrderPay;
